export const zx = [
  {
    name: '闽教高分',
    mark: 'mjqk',
    press: '福建教育出版社',
    business_id: 100009,
    app_id: 1471485274,
    ios_schema: 'mjqiaokao',
    android_schema: 'com.zhl.mjqk.aphone'
  },
  {
    name: '冀教高分',
    mark: 'jjqk',
    press: '河北教育出版社',
    business_id: 100007,
    app_id: 1471485422,
    ios_schema: 'jjqiaokao',
    android_schema: 'com.zhl.jjqk.aphone'
  },
  {
    name: '浙教高分',
    mark: 'zjqk',
    press: '浙江教育出版社',
    business_id: 100002,
    app_id: 1458075703,
    ios_schema: 'zjqiaokao',
    android_schema: 'com.zhl.zjqk.aphone'
  },
  {
    name: '巧考',
    mark: 'qk',
    press: '',
    business_id: 100001,
    app_id: 1458305565,
    ios_schema: 'qiaokao',
    android_schema: 'com.zhl.qk.aphone'
  },
  {
    name: '湖北教育中学版',
    mark: 'hbqk',
    new_mark: 'hbjy',
    press: '湖北教育出版社',
    business_id: 100020,
    app_id: 1497863030,
    ios_schema: 'hbjyqiaokao',
    android_schema: 'com.zhl.hbqk.aphone'
  },
  {
    name: '海教高分',
    mark: 'haijiaoqk',
    new_mark: 'hjgf',
    press: '海教高分',
    business_id: 100031,
    appId: 1513876490,
    ios_schema: 'hjqiaokao',
    android_schema: 'com.zhl.haijiaoqk.aphone'
  },
  {
    name: '辽海高分',
    mark: 'lhqk',
    press: '辽海教育出版社',
    business_id: 100023,
    app_id: 1497862734,
    ios_schema: 'lhqiaokao',
    android_schema: 'com.zhl.lhqk.aphone'
  },
  {
    name: '龙教高分',
    mark: 'hljqk',
    press: '黑龙江教育出版社',
    business_id: 100022,
    app_id: 1492779232,
    ios_schema: 'hljqiaokao',
    android_schema: 'com.zhl.hljqk.aphone'
  },
  {
    name: '苏科优学中学版',
    mark: 'skqk',
    press: '江苏科学技术出版社',
    business_id: 100029,
    app_id: 1508444718,
    ios_schema: 'skqiaokao',
    android_schema: 'com.zhl.skqk.aphone'
  },
  {
    name: '名校学习',
    mark: 'sjhzqk',
    press: '湖北世纪华章文化传播有限公司',
    business_id: 100024,
    app_id: 1497863295,
    ios_schema: 'mxqiaokao',
    android_schema: 'com.zhl.sjhzqk.aphone'
  },
  {
    name: '安教慧学',
    mark: 'asqk',
    press: '安徽少年儿童出版社',
    business_id: 100006,
    app_id: 1471485657,
    ios_schema: 'asqiaokao',
    android_schema: 'com.zhl.asqk.aphone'
  },
  {
    name: '优化高分',
    mark: 'yhqk',
    press: '世纪天鸿',
    business_id: 100003,
    app_id: 1463370037,
    ios_schema: 'yhqiaokao',
    android_schema: 'com.zhl.yhqk.aphone'
  },
  {
    name: '渝快学中学版',
    mark: 'yujiaoqk',
    press: '重庆出版集团',
    business_id: 100027,
    app_id: 1500389287,
    ios_schema: 'ykxqiaokao',
    android_schema: 'com.zhl.yujiaoqk.aphone'
  },
  {
    name: '云教高分',
    mark: 'yjqk',
    press: '云南教育出版社',
    business_id: 100012,
    app_id: 1485838950,
    ios_schema: 'yjqiaokao',
    android_schema: 'com.zhl.yjqk.aphone'
  },
  {
    name: '长少高分',
    mark: 'csqk',
    press: '长江少儿出版社',
    business_id: 100025,
    app_id: 1497863226,
    ios_schema: 'csqiaokao',
    android_schema: 'com.zhl.csqk.aphone'
  },
  {
    name: '桂教高分',
    mark: 'guijiaoqk',
    press: '广西教育出版社',
    business_id: 100028,
    app_id: 1500680538,
    ios_schema: 'gjqiaokao',
    android_schema: 'com.zhl.guijiaoqk.aphone'
  }
]
